import FacebookLoginButton from "components/Buttons/FacebookLoginButton";
import ScopelyLoginButton from "components/Buttons/ScopelyLoginButton";
import { FeaturesFlags } from "helpers";
import { useEnvContext } from "contexts";
import { useLinks } from "hooks/useLinks";
import {
	ButtonsContainer,
	Container,
	PrivacyLink,
	Subtitle,
	Title
} from "./styles";

interface Props {
	title?: string;
	subtitle?: string;
	source?: string;
}

const LoginBox = ({
	title = "Welcome!",
	subtitle = "Sign in to enter the Web Shop.",
	source = "login_to_continue_dialog#shop"
}: Props) => {
	const { isFeatureFlagEnabled } = useEnvContext();
	const { privacy } = useLinks();

	return (
		<Container>
			<Title>{title}</Title>
			<Subtitle>{subtitle}</Subtitle>
			<ButtonsContainer>
				{isFeatureFlagEnabled(FeaturesFlags.SCOPELY_LOGIN) && (
					<ScopelyLoginButton
						source={source}
						style={{
							borderRadius: "16px",
							fontSize: "0.9em",
							height: "3.1em",
							display: "flex",
							justifyContent: "center",
							alignItems: "center"
						}}
					/>
				)}
				<FacebookLoginButton
					source={source}
					style={{
						borderRadius: "16px",
						fontSize: "0.9em",
						height: "3.1em",
						display: "flex",
						justifyContent: "center",
						alignItems: "center"
					}}
					styleNoButton={{
						marginTop: "0.4em",
						fontSize: "0.68em"
					}}
				/>
			</ButtonsContainer>
			{privacy && (
				<PrivacyLink
					href={privacy.path || "#"}
					title={privacy.title}
					target={privacy.target || "_blank"}
					rel="noreferrer"
				>
					<strong>{privacy.title}</strong>
				</PrivacyLink>
			)}
		</Container>
	);
};

export default LoginBox;
